<app-navbar *ngIf="userService.isValidUser()"></app-navbar>
<router-outlet></router-outlet>
<app-footer></app-footer>

<!-- Toaster -->
<div toastNotification></div>
